import { ITurno } from "../models/turno";

interface ITurnoItemProps {
    value: ITurno;
}

const TurnoItem = (props: ITurnoItemProps): JSX.Element => {

    return <div className='item'>
        <div><div>{props.value.moduleNumber}</div></div>
        <div><div>{props.value.turnoNumber}</div></div>
    </div>;
}

export default TurnoItem;